import {
  CANVAS_AREA_MARGIN_TOP,
  CANVAS_AREA_MARGIN_TOP_SMALL,
  NEW_RECENT_OFFSET,
  canvasContextMenuEnum,
  nextGenFlyoutPanelEnum,
  nextGenSidebarTabKeyEnum,
  nextgenBreakpoints,
  nextgenNodeId,
  nextgenScreenMode,
  sidebarTabIdMap,
} from './constants';
import { changeArtColor, selectImageForNonDigital, unSelectAllImage, unSelectAllText } from '../canvas/actions';
import {
  changeElementApplyingStatus,
  changeNextgenUiStatus,
  setCurrentBomOption,
  setNextgenCurrentStep,
} from './actions';
import {
  getAllowMultipleArts,
  getBomPreviewColorCode,
  getCurrentImprintAreaKey,
  getSelectedTextColor,
  getSidebarTabKey,
  getStudioItemType,
  getVendorId,
} from '../main/selectors';
import { getCurrentBomOption, getRecentBomOptionsList } from './product/selectors';
import { getFirstImage, hasTempElementOrBackground } from './main/MainPanel/selectors';
import {
  getImprintAreaCustomizedWithoutSpecialImage,
  getImprintColors,
  getSpecialImageLabelOfNoAdded,
  getTempSelectedImprintAreaKeys,
} from '../imprintarea/selectors';
import { getIsStackPanelShow, getNextgenUiCurrentButtonType, getNextgenUiStepSettings } from './selectors';
import {
  hideTransparencyCover,
  hideWaitingCover,
  setElementDragFlag,
  showConfirmDialog,
  showMessageBox,
  showTransparencyCover,
  showWaitingCover,
} from '../main/actions';
import { nextgenUiSelectImprintArea, outsideUserImageMatch } from '../imprintarea/logics';
import { sidebarTabKeyEnum, userImageType } from '../utils/constants';

import { MATCHTRIMCODE } from '../imprintarea/constants';
import { changeColorOrNumber } from '../uploadimage/logics';
import { changeCurrentBomOption } from '../imprintarea/logics';
import { changePreviewDefaultImprintColor } from '../preview/logics';
import { changeSidebarTabKey } from '../sidebar/actions';
import { changeTextColorAsync } from '../imprintarea/logics';
import { getAllAppliedImprintAreaKeys } from '../imprintarea/selectors';
import { getAllNextGenUIImprintAreaKeys } from '../imprintarea/selectors';
import { getCurrentImprintFormat } from '../imprintarea/selectors';
import { getDeviceViewPort } from '../utils/device';
import { getLeftFlyoutStoreData } from './sidebar/LeftFlyout/selectors';
import { getMatchTrimColor } from '../bom/selectors';
import { getNextgenUiStatus } from './sidebar/LeftFlyout/selectors';
import { isMobileOnly } from 'react-device-detect';
import { nextgenBomFinished } from '../main/logics';
import { nextgenUiStepButtons } from '../main/constants';
import { nextgenUiSteps } from '../main/constants';
import { nextgenValidateImprintRequired } from '../main/logics';
import { rgbToCMYK } from '../utils';
import { saveBlankProjectConfirmAsync } from '../main/logics';
import { specialImageMandatoryMissingCheckAsync } from '../userimage/logics';
import { studioItemType as studioItemTypeEnum } from '../main/constants';
import { validateCurrentImprintAreaInternalInvalid } from '../main/logics';
import { validateImprintRequiredResult } from './constants';

export const getScreenMode = () => {
  const viewPort = getDeviceViewPort();
  return viewPort.width < nextgenBreakpoints.md
    ? nextgenScreenMode.small
    : viewPort.width < nextgenBreakpoints.lg
    ? nextgenScreenMode.middle
    : nextgenScreenMode.large;
};

export const isExtraSmall = () => {
  const viewPort = getDeviceViewPort();
  return viewPort.width < nextgenBreakpoints.sm;
};

export const isExtraLarge = () => {
  const viewPort = getDeviceViewPort();
  return viewPort.width >= nextgenBreakpoints.xl;
};

export const is2ExtraLarge = () => {
  const viewPort = getDeviceViewPort();
  return viewPort.width >= nextgenBreakpoints.xxl;
};

export const nextGenChangeSideBarKey = (params) => {
  const { newKey, dispatch, canvasKey, studioItemType } = params;
  dispatch(unSelectAllImage({ canvasKey, studioItemType }));
  dispatch(unSelectAllText({ canvasKey }));
  dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: null }));

  dispatch(changeSidebarTabKey(newKey));

  if (
    newKey === nextGenSidebarTabKeyEnum.Slogan ||
    newKey === nextGenSidebarTabKeyEnum.Verse ||
    newKey === nextGenSidebarTabKeyEnum.Sentiment
  ) {
    dispatch(selectImageForNonDigital({ canvasKey, sidebarTabKey: newKey }));
  }

  if (newKey === nextGenSidebarTabKeyEnum.None) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.GetStarted) {
    if (isMobileOnly) {
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
    } else {
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
    }
  } else if (newKey === nextGenSidebarTabKeyEnum.Product) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.ProductPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Uploads) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.UploadPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Graphics) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GraphicPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Text) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.AddTextPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Background) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.BackgroundPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Slogan) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.SloganPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Verse) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.VersePanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Sentiment) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.SentimentPanel } }));
  } else if (newKey === nextGenSidebarTabKeyEnum.Help) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.Help } }));
  }
};

export const changePanelForSingleSelect = (dispatch, selectedElementData, studioItemType) => {
  if (typeof selectedElementData.imprintText != 'undefined') {
    dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Text));
    dispatch(
      changeNextgenUiStatus({
        flyoutPanel: {
          currentPanel:
            getScreenMode() === nextgenScreenMode.small
              ? nextGenFlyoutPanelEnum.None
              : nextGenFlyoutPanelEnum.EditTextPanel,
        },
        canvasContextMenu: { menuItems: [canvasContextMenuEnum.Copy, canvasContextMenuEnum.Delete] },
      })
    );
  } else {
    if (
      selectedElementData.type === userImageType.UploadLogo ||
      selectedElementData.type === userImageType.SavedArt ||
      selectedElementData.type === userImageType.SharedArt
    ) {
      dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Uploads));
      dispatch(
        changeNextgenUiStatus({
          flyoutPanel: {
            currentPanel:
              getScreenMode() === nextgenScreenMode.small
                ? nextGenFlyoutPanelEnum.None
                : nextGenFlyoutPanelEnum.EditImagePanel,
          },
          canvasContextMenu: { menuItems: [canvasContextMenuEnum.Copy, canvasContextMenuEnum.Delete] },
        })
      );
    } else if (
      selectedElementData.type === userImageType.StockArt ||
      (selectedElementData.type === userImageType.Slogan && !selectedElementData.isOutside)
    ) {
      dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Graphics));
      dispatch(
        changeNextgenUiStatus({
          flyoutPanel: {
            currentPanel:
              getScreenMode() === nextgenScreenMode.small
                ? nextGenFlyoutPanelEnum.None
                : nextGenFlyoutPanelEnum.GraphicPanel,
          },
          canvasContextMenu: { menuItems: [canvasContextMenuEnum.Copy, canvasContextMenuEnum.Delete] },
        })
      );
    }
  }

  if (getScreenMode() === nextgenScreenMode.small)
    dispatch(changeNextgenUiStatus({ elementToScroll: selectedElementData }));
};

export const changePanelForBatchSelect = (dispatch) => {
  const screenMode = getScreenMode();
  if (screenMode !== nextgenScreenMode.small) {
    dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Text));
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.EditBatchTextPanel } }));
  }
};

export const changeSideBarToLogoArt =
  ({ canvasKey, studioItemType, newKey, fromCanvas }) =>
  (dispatch, getState) => {
    const state = getState();
    const hasTemp = hasTempElementOrBackground(state);
    const firstArt = getFirstImage(state);
    const allowMultipleArts = getAllowMultipleArts(state);

    dispatch(unSelectAllImage({ canvasKey, studioItemType }));
    dispatch(unSelectAllText({ canvasKey }));
    dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: null }));

    dispatch(changeSidebarTabKey(newKey));

    if (studioItemType !== studioItemTypeEnum.screenPrintedDigital || allowMultipleArts) {
      const targetPanel =
        newKey === nextGenSidebarTabKeyEnum.Uploads
          ? nextGenFlyoutPanelEnum.UploadPanel
          : nextGenFlyoutPanelEnum.GraphicPanel;
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: targetPanel } }));
      return;
    }

    // following are for screen printed
    if (hasTemp) return;

    if (firstArt) {
      if (fromCanvas) {
        //dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
        nextGenChangeSideBarKeyToGetStarted({ dispatch, canvasKey, studioItemType });
        //nextGenChangeSideBarKey({ newKey: nextGenSidebarTabKeyEnum.GetStarted, dispatch, canvasKey, studioItemType });
      } else {
        dispatch(selectImageForNonDigital({ canvasKey, sidebarTabKey: sidebarTabKeyEnum.Logo }));
        const type = firstArt.data.type;
        let targetPanel;
        if (type === userImageType.UploadLogo || type === userImageType.SharedArt || type === userImageType.SavedArt) {
          targetPanel = nextGenFlyoutPanelEnum.EditImagePanel;
          dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Uploads));
        } else if (type === userImageType.StockArt) {
          targetPanel = nextGenFlyoutPanelEnum.GraphicPanel;
          dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Graphics));
        } else {
          if (isMobileOnly) {
            targetPanel = nextGenFlyoutPanelEnum.None;
          } else {
            targetPanel = nextGenFlyoutPanelEnum.GetStartedPanel;
          }
        }
        dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: targetPanel } }));
      }
    } else {
      const targetPanel =
        newKey === nextGenSidebarTabKeyEnum.Uploads
          ? nextGenFlyoutPanelEnum.UploadPanel
          : nextGenFlyoutPanelEnum.GraphicPanel;
      dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: targetPanel } }));
    }
  };

export const nextgenContainerClick = (dispatch, storeData, e) => {
  const { canvasKey, studioItemType, hasSingleSelectedElement, hasTempElementOrBackground, sidebarTabKey } = storeData;
  const nodeId = e.target.id;
  const screenMode = getScreenMode();

  if (
    nodeId === nextgenNodeId.canvasContent ||
    nodeId === nextgenNodeId.canvasContainer ||
    nodeId === nextgenNodeId.canvasProductImage
  ) {
    //nextGenChangeSideBarKey({ newKey: nextGenSidebarTabKeyEnum.None, dispatch, canvasKey, studioItemType });
    return;
  }

  if (
    nodeId === nextgenNodeId.configuratorContainer ||
    nodeId === nextgenNodeId.leftSideBar ||
    nodeId === nextgenNodeId.toolbarContainer ||
    nodeId === nextgenNodeId.leftSideBarToolList ||
    nodeId === nextgenNodeId.nextgenNavbar
  ) {
    nextGenChangeSideBarKeyToGetStarted({ dispatch, canvasKey, studioItemType });
    //nextGenChangeSideBarKey({ newKey: nextGenSidebarTabKeyEnum.GetStarted, dispatch, canvasKey, studioItemType });
  } else if (e.target.nodeName === 'CANVAS') {
    if (
      screenMode !== nextgenScreenMode.small &&
      !hasSingleSelectedElement &&
      !hasTempElementOrBackground &&
      (sidebarTabKey === nextGenSidebarTabKeyEnum.Uploads || sidebarTabKey === nextGenSidebarTabKeyEnum.Graphics)
    ) {
      dispatch(changeSideBarToLogoArt({ canvasKey, studioItemType, newKey: sidebarTabKey, fromCanvas: true }));
    } else {
      dispatch(setElementDragFlag(false));
    }
  }
};

export const nextGenChangeSideBarKeyToGetStarted = (params) => {
  const { dispatch, canvasKey, studioItemType } = params;
  if (isMobileOnly) {
    nextGenChangeSideBarKey({ newKey: nextGenSidebarTabKeyEnum.None, dispatch, canvasKey, studioItemType });
  } else {
    nextGenChangeSideBarKey({ newKey: nextGenSidebarTabKeyEnum.GetStarted, dispatch, canvasKey, studioItemType });
  }
};

export const changeNextgenUiStatusToGetStarted = (dispatch) => {
  if (isMobileOnly) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
  } else {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
  }
};

export const getAvailableHeight = () => {
  const screenMode = getScreenMode();
  const viewPort = getDeviceViewPort();
  const marginTop =
    screenMode === nextgenScreenMode.small || screenMode === nextgenScreenMode.middle
      ? CANVAS_AREA_MARGIN_TOP_SMALL
      : CANVAS_AREA_MARGIN_TOP;
  const height = viewPort.height - marginTop - 30;
  return height;
};
const updateElementColorForTrim = () => (dispatch, getState) => {
  let state = getState();
  const vendor_id = getVendorId(state);
  const studioItemType = getStudioItemType(state);
  const matchTrimColor = getMatchTrimColor(state);

  if (matchTrimColor.hasTrimColor) {
    const selectedImprintAreaKeys = getTempSelectedImprintAreaKeys(state);
    const trimColorReference = matchTrimColor.colorReference.replace('#', '');
    selectedImprintAreaKeys.forEach((imprintAreaKey) => {
      const selectedTextColor = getSelectedTextColor(state, imprintAreaKey);
      if (
        MATCHTRIMCODE.includes(selectedTextColor?.colorId) &&
        selectedTextColor.colorReference !== trimColorReference
      ) {
        dispatch(
          changeTextColorAsync({
            formatkey: imprintAreaKey,
            color: Object.assign({}, selectedTextColor, {
              colorReference: trimColorReference,
              cmyk: rgbToCMYK(trimColorReference),
            }),
          })
        );
      }

      if (state.imageDict && state.imageDict[imprintAreaKey]) {
        const imprintColorList = getImprintColors(state, imprintAreaKey);

        //excluding outside UserImage
        const images = state.imageDict[imprintAreaKey].filter((x) => !outsideUserImageMatch(x.data));
        if (images) {
          images.forEach((img) => {
            const newImage = {
              data: Object.assign({}, img.data),
              ui: Object.assign({}, img.ui),
            };
            let hasNewTrimColor = false;
            const newColors = newImage.data.colors?.map((color) => {
              let newColor = color;
              if (MATCHTRIMCODE.includes(color.colorId) && color.colorReference !== trimColorReference) {
                if (!hasNewTrimColor) hasNewTrimColor = true;
                newColor = Object.assign({}, color, {
                  colorReference: trimColorReference,
                  cmyk: rgbToCMYK(trimColorReference),
                });
              }
              return newColor;
            });
            if (hasNewTrimColor) {
              dispatch(
                changeArtColor({
                  canvasKey: imprintAreaKey,
                  guid: newImage.ui.guid,
                  colors: newColors,
                })
              );

              if (newImage.data.type === userImageType.UploadLogo)
                changeColorOrNumber({
                  dispatch,
                  canvasKey: imprintAreaKey,
                  imprintColorList,
                  studioItemType,
                  vendorId: vendor_id,
                  image: newImage,
                  colorList: newColors,
                  isChangeNumber: false,
                });
            }
          });
        }
      }
    });
  }
};
export const moveToNextFromProductDetailsAsync = () => {
  return (dispatch, getState) => {
    const state = getState();

    const colorCodes = getBomPreviewColorCode(state);
    const colorChangeable = !!colorCodes && colorCodes.length === 1;
    if (colorChangeable) {
      const { uniqueOptions } = state;
      const options = uniqueOptions[colorCodes[0].toUpperCase()];
      const selectedOptions = options.filter((option) => option.isSelected);
      const currentBomOption = getCurrentBomOption(state);
      const currentBomOptionNotFound =
        !!currentBomOption &&
        !selectedOptions.some(
          (option) => option.code === currentBomOption.code && option.codeValue === currentBomOption.codeValue
        );
      if (!currentBomOption || currentBomOptionNotFound) {
        const recentBomOptions = getRecentBomOptionsList(state);
        let newCurrentBomOption =
          selectedOptions.length > 0 ? selectedOptions[0] : options.length > 0 ? options[0] : null;
        if (recentBomOptions.length > 0) {
          const mostRecentOption = recentBomOptions[recentBomOptions.length - 1];
          newCurrentBomOption = selectedOptions.find(
            (option) => option.code === mostRecentOption.code && option.codeValue === mostRecentOption.codeValue
          );
        }
        dispatch(changeCurrentBomOption(newCurrentBomOption));
      }
    }

    // Todo: Check if this statement is still necessary.
    // For now, there is no need to pass in any bom option as the parameter,
    // since setting the current bom option has already been done in the logic above.

    const stepSettings = getNextgenUiStepSettings(state);
    const currentButtonType = getNextgenUiCurrentButtonType(state);
    if (Object.keys(stepSettings.steps).length === 1 && currentButtonType === nextgenUiStepButtons.AddToCart) {
      dispatch(showWaitingCover());
      dispatch(nextgenBomFinished());
    } else {
      const imprintAreaKeys = getAllNextGenUIImprintAreaKeys(state);
      dispatch(setNextgenCurrentStep(nextgenUiSteps.Customize));
      dispatch(changePreviewDefaultImprintColor({ imprintAreaKeys }));
      dispatch(updateElementColorForTrim());
    }
  };
};

const changeSidebarFocus = (focusId, isRightDown, sidebarItemList) => {
  const sidebarIconIds = sidebarItemList.map((item) => sidebarTabIdMap[item]);
  let index = sidebarIconIds.indexOf(focusId);
  if (index !== -1) {
    if (isRightDown) index = index + 1 >= sidebarIconIds.length ? 0 : index + 1;
    else index = index - 1 < 0 ? sidebarIconIds.length - 1 : index - 1;
    document.getElementById(sidebarIconIds[index])?.focus();
    return true;
  }
  return false;
};

const changeUploadPanelFocus = (focusId) => {
  if (focusId === nextgenNodeId.uploadPanelUploads) {
    document.getElementById(nextgenNodeId.uploadPanelRecent)?.focus();
    return true;
  } else if (focusId === nextgenNodeId.uploadPanelRecent) {
    document.getElementById(nextgenNodeId.uploadPanelUploads)?.focus();
    return true;
  }
  return false;
};

export const processArrowKeyAsync =
  ({ key }) =>
  (_, getState) => {
    const state = getState();
    const sidebarTabKey = getSidebarTabKey(state);
    const nextgenUiStatus = getNextgenUiStatus(state);
    const currentPanel = nextgenUiStatus.flyoutPanel.currentPanel;
    const sidebarItemList = nextgenUiStatus.sidebarItemList;
    const focusId = document.activeElement.id;

    if (key !== 'ArrowUp' && key !== 'ArrowLeft' && key !== 'ArrowDown' && key !== 'ArrowRight') return;
    const isRightDown = key === 'ArrowRight' || key === 'ArrowDown';

    if (changeUploadPanelFocus(focusId, isRightDown)) return;
    if (sidebarItemList) {
      if (changeSidebarFocus(focusId, isRightDown, sidebarItemList)) return;
    }

    if (isRightDown) {
      if (focusId === nextgenNodeId.leftSideBarToolList) {
        if (sidebarTabKey === nextGenSidebarTabKeyEnum.None || sidebarTabKey === nextGenSidebarTabKeyEnum.None)
          document.getElementById(nextgenNodeId.sideBarProduct)?.focus();
        else document.getElementById(sidebarTabIdMap[sidebarTabKey])?.focus();
      } else if (focusId === nextgenNodeId.flyoutPanelContent) {
        if (currentPanel === nextGenFlyoutPanelEnum.UploadPanel) {
          document.getElementById(nextgenNodeId.uploadPanelUploads)?.focus();
        }
      }
    } else {
      if (focusId === nextgenNodeId.leftSideBarToolList) {
        if (sidebarTabKey === nextGenSidebarTabKeyEnum.None || sidebarTabKey === nextGenSidebarTabKeyEnum.None)
          document.getElementById(nextgenNodeId.sideBarHelp)?.focus();
        else document.getElementById(sidebarTabIdMap[sidebarTabKey])?.focus();
      } else if (focusId === nextgenNodeId.flyoutPanelContent) {
        if (currentPanel === nextGenFlyoutPanelEnum.UploadPanel) {
          document.getElementById(nextgenNodeId.uploadPanelRecent)?.focus();
        }
      } else if (focusId === nextgenNodeId.leftSideBar) {
        const parentElement = document.querySelector('#topbar-container-id');
        if (parentElement) {
          const allElements = parentElement.getElementsByTagName('*');
          const matchedElements = Array.from(allElements).filter((el) => {
            return (
              typeof el.className === 'string' && el.className.split(' ').some((cls) => cls.endsWith('next-button'))
            );
          });
          matchedElements[0]?.focus();
        }
      }
    }
  };

export const processTabKey = ({ key, shiftKey }) => {
  const focusId = document.activeElement.id;
  if (key !== 'Tab') return;

  if ((focusId === 'nextgen-header-menubar' || focusId === 'logo') && !shiftKey) {
    const buttonGetStarted = document.getElementById('button-skip-to-getstarted');
    if (buttonGetStarted) {
      document.getElementById('button-skip-to-getstarted')?.focus();
    } else {
      document.getElementById('button-skip-to-toolbar')?.focus();
    }
    return true;
  } else if (shiftKey && (focusId === 'exit-button-id' || focusId === 'menu-hamburger-container')) {
    document.getElementById('logo')?.focus();
    return true;
  }
  return false;
};

export const useOffCanvasForFlyout = (currentFlyoutPanel) => {
  const traditionalFlyoutPanelList = [nextGenFlyoutPanelEnum.GetStartedPanel];
  const screenMode = getScreenMode();
  if (currentFlyoutPanel)
    return screenMode === nextgenScreenMode.small && !traditionalFlyoutPanelList.find((m) => m === currentFlyoutPanel);
  else return screenMode === nextgenScreenMode.small;
};

export const speakText = (text) => {
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'en-US';
  window.speechSynthesis.speak(utterance);
};

export const switchElementApplyingStatus =
  ({ element, elementIndex, type, isUpload, isApplying }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentImprintFormat = getCurrentImprintFormat(state);

    if (isApplying || (type === userImageType.RecentArt && !isUpload) || type === userImageType.SharedArt) {
      dispatch(changeNextgenUiStatus({ showCanvasCover: isApplying }));
      isApplying ? dispatch(showTransparencyCover()) : dispatch(hideTransparencyCover());
    }

    switch (type) {
      case userImageType.SavedArt:
        dispatch(
          changeElementApplyingStatus({
            processType: currentImprintFormat.processType,
            imprintAreaCode: currentImprintFormat.imprintAreaCode,
            element,
            status: isApplying,
          })
        );
        break;
      case userImageType.SharedArt:
        dispatch(
          changeElementApplyingStatus({
            imprintAreaKey: currentImprintFormat.key,
            element,
            status: isApplying,
          })
        );
        break;
      case userImageType.RecentArt:
        dispatch(
          changeElementApplyingStatus({
            imprintAreaCode: currentImprintFormat.imprintAreaCode,
            elementIndex,
            status: isApplying,
          })
        );
        break;
    }
  };

export const backToElementMainPanel = (elementData) => (dispatch) => {
  if (
    elementData.type === userImageType.UploadLogo ||
    elementData.type === userImageType.SavedArt ||
    elementData.type === userImageType.SharedArt
  ) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.UploadPanel } }));
  } else if (elementData.type === userImageType.StockArt) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GraphicPanel } }));
  } else if (elementData.type === userImageType.Slogan && elementData.isOutside) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.SloganPanel } }));
  } else if (elementData.type === userImageType.Verse) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.VersePanel } }));
  } else if (elementData.type === userImageType.Sentiment) {
    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.SentimentPanel } }));
  }
};

export const offsetNewRecentArtOrText = (newElement, existingImagesOrTexts, newElementGuid) => {
  for (var i = 0; i < existingImagesOrTexts.length; i++) {
    const samePosAndSize = existingImagesOrTexts.find(
      (element) =>
        element.ui.guid !== newElementGuid &&
        Math.abs(element.data.x - newElement.data.x) <= 1 &&
        Math.abs(element.data.y - newElement.data.y) <= 1
    );
    if (samePosAndSize) {
      newElement.data.x += NEW_RECENT_OFFSET;
      newElement.data.y += NEW_RECENT_OFFSET;
    }
  }
};

export const isPanelInChain = (flyoutPanelChain, panel) => {
  let found = false;
  flyoutPanelChain.forEach((chain) => {
    if (chain.indexOf(panel) !== -1) {
      found = true;
    }
  });
  return found;
};

export const getPanelChain = (flyoutPanelChain, currentPanel, closeCurrentPanel) => {
  let result = null;
  const chainFiltered = [];
  flyoutPanelChain.forEach((chain) => {
    if (chain.indexOf(currentPanel) !== -1) {
      const currentIndex = chain.indexOf(currentPanel);
      if (currentIndex === 0 && closeCurrentPanel) return null;
      const resultChain = chain.slice(0, currentIndex + 1 - (closeCurrentPanel ? 1 : 0));
      const exists = chainFiltered.some((c) => areArraysEqual(c, resultChain));
      if (!exists) {
        chainFiltered.push(resultChain);
      }
    }
  });

  return chainFiltered.length > 0 ? chainFiltered : null;
};

const areArraysEqual = (a, b) => {
  if (a.length !== b.length) return false;
  return a.every((v, i) => v === b[i]);
};

export const getPanelList = (stackPanelChain, currentPanel, isSingleSelectedText) => {
  let panelList = [];
  if (stackPanelChain && stackPanelChain.length > 1) {
    const current = stackPanelChain[0].find((panel) => panel === currentPanel);

    if (current === nextGenFlyoutPanelEnum.TextFontPanel || current === nextGenFlyoutPanelEnum.TextColorPanel) {
      stackPanelChain.some((list) => {
        if (isSingleSelectedText) {
          const target = list.find((panel) => panel === nextGenFlyoutPanelEnum.EditTextPanel);
          if (target) {
            panelList = list;
            return true;
          }
        } else {
          const target = list.find((panel) => panel === nextGenFlyoutPanelEnum.EditBatchTextPanel);
          if (target) {
            panelList = list;
            return true;
          }
        }
      });
    }
  } else if (stackPanelChain && stackPanelChain.length === 1) {
    panelList = stackPanelChain[0];
  } else {
    panelList = [currentPanel];
  }

  return panelList;
};

export const validateImprintRequiredForSavingProject = (doAfterValidate) => (dispatch, getState) => {
  if (!dispatch(validateCurrentImprintAreaInternalInvalid())) {
    return false;
  }

  const validateResult = dispatch(nextgenValidateImprintRequired());

  if (
    validateResult === validateImprintRequiredResult.GroupError ||
    validateResult === validateImprintRequiredResult.ItemError
  ) {
    dispatch(
      showMessageBox({
        show: true,
        title: 'Imprint is Required',
        message: 'Please add an imprint to save your project.',
      })
    );
    return false;
  } else if (validateResult === validateImprintRequiredResult.Confirm) {
    saveBlankProjectConfirmAsync(dispatch).then((res) => {
      if (res) {
        doAfterValidate();
        return true;
      } else {
        return false;
      }
    });
    return false;
  } else if (validateResult === validateImprintRequiredResult.Valid) {
    dispatch(
      checkNoAddSpecialImage({
        onOk: () => {
          doAfterValidate();
          return true;
        },
      })
    );

    return false;
  }
};

export const checkNoAddSpecialImage =
  ({ onOk }) =>
  (dispatch, getState) => {
    const state = getState();
    const allAppliedImprintAreaKeys = getAllAppliedImprintAreaKeys(state);
    const currentImprintAreaKey = getCurrentImprintAreaKey(state);
    for (const imprintAreaKey of allAppliedImprintAreaKeys) {
      const specialImageLabelOfNoAdded = getSpecialImageLabelOfNoAdded(state, imprintAreaKey);
      if (specialImageLabelOfNoAdded) {
        dispatch(hideWaitingCover());
        const surfaceDescription = state.imprintAreaDict[imprintAreaKey]?.description;
        let showSpecialImageMissingConfirm = () => {
          dispatch(
            showConfirmDialog({
              show: true,
              title: `You have not added your ${specialImageLabelOfNoAdded} to ${surfaceDescription} surface, do you want to add it?`,
              message: '',
              okText: `I don't want to add ${specialImageLabelOfNoAdded}`,
              cancelText: `I want to add ${specialImageLabelOfNoAdded}`,
              onOk: () => onOk && onOk(),
            })
          );
        };
        const isApplied = getImprintAreaCustomizedWithoutSpecialImage(state, imprintAreaKey);
        if (isApplied) {
          const specialImageMandatoryMissingType = dispatch(
            specialImageMandatoryMissingCheckAsync({ formatkey: imprintAreaKey })
          );
          if (specialImageMandatoryMissingType !== userImageType.NotSet) {
            showSpecialImageMissingConfirm = () => {
              dispatch(
                showMessageBox({
                  show: true,
                  message: `Please add a ${specialImageLabelOfNoAdded} selection to ${surfaceDescription} surface for the item to continue.`,
                  title: `${specialImageLabelOfNoAdded} is Required`,
                  onOk: () => {
                    if (currentImprintAreaKey !== imprintAreaKey) dispatch(nextgenUiSelectImprintArea(imprintAreaKey));
                  },
                })
              );
            };
          }
        }
        showSpecialImageMissingConfirm();
        return;
      }
    }
    onOk && onOk();
  };

export const flyoutGestureHandler = () => (dispatch, getState) => {
  const state = getState();

  const isStackPanelShow = getIsStackPanelShow(state);
  const { canvasKey, nextgenUiStatus, isSingleSelectedText } = getLeftFlyoutStoreData(state);
  const stackPanelChain = nextgenUiStatus.flyoutPanel.stackPanelChain;
  const currentPanel = nextgenUiStatus.flyoutPanel.currentPanel;
  const panelList = getPanelList(stackPanelChain, currentPanel, isSingleSelectedText);
  const panelIndexInChain = panelList.length - 1;
  const studioItemType = getStudioItemType(state);

  if (isStackPanelShow && panelIndexInChain > 0) {
    const previousIndex = panelIndexInChain - 1;
    const previousPanel = panelList[previousIndex];

    if (previousIndex === 0) {
      dispatch(unSelectAllText({ canvasKey }));
      dispatch(unSelectAllImage({ canvasKey, studioItemType }));
      dispatch(changeNextgenUiStatus({ canvasKey, canvasFocusElement: null }));

      if (currentPanel === nextGenFlyoutPanelEnum.EditImagePanel) {
        const allowMultipleArts = getAllowMultipleArts(state);
        if (!allowMultipleArts) {
          nextGenChangeSideBarKey({ dispatch, canvasKey, studioItemType, newKey: nextGenSidebarTabKeyEnum.None });
          return;
        }
      }
    }

    dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: previousPanel } }));
  } else {
    nextGenChangeSideBarKey({ dispatch, canvasKey, studioItemType, newKey: nextGenSidebarTabKeyEnum.None });
  }
};
